import { Divider } from "@mui/material";
import React, { useEffect, useState } from "react"
import { useNavigate, NavLink } from "react-router-dom";
import "../pages/styles/footer.scss"

const contentWidth = document.documentElement.clientWidth || document.body.clientWidth;

export const Footer = () => {

    const [isPhone, setIsPhone] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getWidth();
    }, [])
    const getWidth = () => {
        if (contentWidth <= 600) {
            setIsPhone(true)
        } else {
            setIsPhone(false)
        }
    }




    return (<div>
        <Divider className="top-divider" />
        <div className="footer">
            <div className="foot-right">
                <div style={{display:'flex',alignItems:'center'}}>
                    <NavLink
                            to="/home"
                        style={{ textDecoration: "none" }}>
                        <span
                        className="homelogo"
                            style={{
                                fontFamily: "'Alegreya Sans'",
                                fontWeight: 500,
                                lineHeight: "38px",
                                color: "#003A70",
                                whiteSpace: "nowrap",
                            }}
                        >
                            Bill Reader
                        </span>
                    </NavLink>
                </div>
                {isPhone && <Divider />}
                <ul className="products">
                    <li>Products</li>
                    <li onClick={() => { window.open('https://www.powerlego.com') }}>PowerLego</li>
                    <li onClick={() => { window.open('https://www.eiqhome.com') }}>EIQhome</li>
                    <li onClick={() => { window.open('https://www.eiqshopping.com') }}>EIQShopping</li>
                    <li onClick={() => { window.open('https://www.ESIID.io') }}>ESIID.io</li>
                    <li onClick={() => { window.open('https://www.BillReader.com') }}>BillReader</li>
                    <li style={{ opacity: 0 }} onClick={() => window.open('https://www.personalized.energy/')}>Personalized.Energy</li>
                </ul>
                {isPhone && <Divider />}
                <ul className="company">
                    <li>Company</li>
                    <li onClick={() => { navigate('/about_us') }}>About Us</li>
                </ul>
                {isPhone && <Divider />}
                <ul className="support">
                    <li>Legal & Policies</li>
                    <li onClick={() => { navigate('/terms_of_use') }}>Terms of Use</li>
                    <li onClick={() => { navigate('/privacy_policy') }}>Privacy Policy</li>
                </ul>
                {isPhone && <Divider />}
                <ul className="support">
                    <li>Support & Contact</li>
                    <li onClick={() => { navigate('/contact') }}>Contact Us</li>
                    {/* <li onClick={() => { navigate('/faq') }}>FAQ</li> */}
                </ul>
                {isPhone && <Divider />}
                <ul className="developers">
                    <li>Developers</li>
                    <li onClick={() => window.open('https://documenter.getpostman.com/view/4831254/SzKYPH3c')}>Documentation</li>
                </ul>
                {isPhone && <Divider />}
                <ul className="secure">
                    <li>Secure</li>
                    <li><img width={85} src={require('../pages/images/logo/amazon_logo.png')} alt="" /></li>
                    <li><img height={30} src={require('../pages/images/logo_eiqdigital.png')} alt="" /></li>
                    <li>
                        <div className="foot-left">
                            <p>Foundational building block enabling the digital<br />
                                transformation of the retail energy industry</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>)
}
